import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { pcImageUrl, pcImageFallback } from "../lib/pcImage";
import { useCurrency } from "../context/CurrencyContext";

export default function PossibleMatches({ card, onSelected }) {
  const [selectingIdx, setSelectingIdx] = useState(null);
  const { format } = useCurrency();
  if (card.match_verified || card.reference_image_source === "user_uploaded" || !card.matched_listings?.length) {
    return null;
  }

  const pick = async (listing, idx) => {
    setSelectingIdx(idx);
    try {
      const res = await api.post(`/cards/${card.id}/select-listing`, listing);
      onSelected(res.data);
      toast.success("Match confirmed — image and price updated");
    } catch {
      toast.error("Could not apply that match. Please try again.");
    } finally {
      setSelectingIdx(null);
    }
  };

  return (
    <div data-testid="possible-matches-panel" className="border border-[#F59E0B]/25 bg-[#F59E0B]/5 rounded-xl p-5">
      <p className="text-xs uppercase tracking-widest text-[#F59E0B] mb-1">Possible matches</p>
      <p className="text-xs text-zinc-400 mb-4">
        The AI couldn't visually confirm any of these listings as your exact card. If one is right, tap it to use its image and price.
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {card.matched_listings.slice(0, 6).map((listing, idx) => (
          <button
            key={idx}
            data-testid={`possible-match-${idx}`}
            onClick={() => pick(listing, idx)}
            disabled={selectingIdx !== null}
            className="text-left border border-white/10 rounded-lg overflow-hidden bg-black/30 hover:border-[#A78BFA]/60 transition-colors disabled:opacity-50"
          >
            <div className="aspect-[3/4] bg-black/40">
              {listing.image_url ? (
                <img src={pcImageUrl(listing.image_url, "240")} onError={pcImageFallback} alt={listing.title} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-[10px] text-zinc-600">No image</div>
              )}
            </div>
            <div className="p-2">
              <p className="text-[11px] text-zinc-300 line-clamp-2 leading-tight">{listing.title}</p>
              <p className="font-mono-plex text-xs text-[#A78BFA] mt-1">
                {listing.price != null ? format(listing.price) : ""}
                <span className="text-zinc-500 ml-1.5">{selectingIdx === idx ? "Applying..." : "Use this"}</span>
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
